import { Component } from '@angular/core';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { MangaListComponent } from '../components/manga-list/manga-list.component';
import { UsernomalDTO } from '../model/UsernomalDTO';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UsuariosService } from '../services/usuarios.service';


@Component({
  selector: 'app-perfil',
  standalone: true,
  templateUrl: './perfil.component.html',
  styleUrl: './perfil.component.css',
  imports: [NgIf, NgFor, CommonModule, MangaListComponent, FormsModule]
})
export class PerfilComponent {
  user: UsernomalDTO | null = null; // Datos originales del usuario
  errorMessage: string = ''; // Mensaje de error

  constructor(private route: ActivatedRoute, private usuariosService: UsuariosService, private router: Router) {}

  ngOnInit(): void {
    const userId = this.route.snapshot.paramMap.get('id');
    if (userId) {
      this.fetchUserDetails(userId);
    }
  }

  fetchUserDetails(userId: string): void {
    this.usuariosService.getUserById(userId).subscribe({
      next: (data: UsernomalDTO) => {
        this.user = data;
      },
      error: (error: any) => {
        this.errorMessage = 'Error fetching user details';
        console.error(error);
      }
    });
  }
  navigateToEditProfile(): void {
    const userId = this.route.snapshot.paramMap.get('id'); // Obtén el ID directamente de la URL
    if (userId) {
      this.router.navigate([`edit-profile/user/${userId}`]); // Redirige usando el ID
    } else {
      console.error('No se encontró el ID del usuario en la URL.');
    }
  }

  mangas = [
    { titulo: "Don't Revenge", autor: "Jarson34", imagen: "https://www.britishmuseum.org/sites/default/files/styles/uncropped_huge/public/2022-08/Manga-Golden-Kamuy-692x1024.jpg?itok=htog_9E3" },
    { titulo: "El Príncipe en el Jardín", autor: "Colfeshere & Liliwood", imagen: "https://static1.cbrimages.com/wordpress/wp-content/uploads/2022/11/10-Most-Successful-Manga-Ever-(-How-Many-Copies-Were-Sold).jpg" },
    { titulo: "Arnoldo y Amalia", autor: "Akuarello", imagen: "https://img.freepik.com/vector-gratis/ilustracion-colorear-paginas-anime_23-2151298326.jpg" },
    { titulo: "WARI", autor: "Elban", imagen: "https://dthezntil550i.cloudfront.net/ur/latest/ur2501042348007630005558604/ad4704e1-d2b3-4ffa-8297-2ab9f5a056f4_t.jpg" },
    { titulo: "PERSONAJE", autor: "Saikominc", imagen: "https://www.normaeditorial.com/upload/media/albumes/0001/36/thumb_35047_albumes_medium.jpeg" },
  ];
}


